import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@emotion/react";
import HrmsLightTheme from "./themes/HrmsLightTheme";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import ConfigureStore from "./stores/configureStore";
import { Provider } from "react-redux";
import { SnackbarProvider } from "notistack";
import { CookiesProvider } from "react-cookie";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import ChunkErrorBoundary from "./components/ChunkErrorBoundary";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
export const stores = ConfigureStore();
root.render(
  <CookiesProvider>
    <Provider store={stores}>
      <BrowserRouter>
        <ThemeProvider theme={HrmsLightTheme}>
          <SnackbarProvider maxSnack={3}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <ChunkErrorBoundary>
                <App />
              </ChunkErrorBoundary>
            </LocalizationProvider>
          </SnackbarProvider>
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  </CookiesProvider>
);

// Register PWA Service Worker for offline caching & Lighthouse 100% PWA compliance
serviceWorkerRegistration.register();

reportWebVitals();

